/* @jsx h */
import { defineComponent, h, computed, onMounted } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";
import { getCharacterPackByName } from "../utils/packs";

export type JoinGroupModalProps = {
  onClose: () => void;
  onJoin: () => void;
  isLoading?: boolean;
  characterPackName?: string | null;
};

export const JoinGroupModal = defineComponent<JoinGroupModalProps>({
  name: "JoinGroupModal",
  props: ["onClose", "onJoin", "isLoading", "characterPackName"],
  setup(props) {
    const { t } = useLocalization();
    const characterPack = computed(() => {
      if (!props.characterPackName) return null;
      return getCharacterPackByName(props.characterPackName);
    });
    // hack for now
    onMounted(() => {
      props.onJoin();
    });

    return () => (
      <LemmonModal
        title={undefined}
        onClose={props.onClose}
        renderButtons={() => (
          <div class="flex gap-2 p-2 hidden">
            <button
              onClick={props.onClose}
              class="btn btn-secondary flex-1 hidden"
              disabled={props.isLoading}
            >
              {t("customer.group_order.not_now")}
            </button>
            <button
              onClick={props.onJoin}
              class="btn btn-primary flex-1"
              disabled={props.isLoading}
            >
              {props.isLoading ? (
                <>
                  <span class="loading loading-spinner loading-sm"></span>
                  {t("customer.group_order.joining")}
                </>
              ) : (
                t("customer.group_order.join_group")
              )}
            </button>
          </div>
        )}
      >
        <div class="space-y-6 p-6 hidden">
          <div class="text-center">
            <div class="text-3xl text-accent font-bold mb-2 flex justify-center items-center">
              <span class="material-symbols-outlined mr-1 text-6xl">
                groups
              </span>
              {t("customer.group_order.order_together")}
            </div>
            <div class="text-lg text-base-content/70">
              {t("customer.group_order.join_intro")}
            </div>
          </div>

          {characterPack.value && (
            <>
              <div class="divider">
                {t("customer.group_order.character_pack")}
              </div>

              <div class="card bg-base-200 shadow-sm border">
                <div class="card-body p-4">
                  <div class="flex items-start gap-3">
                    <span class="material-symbols-outlined text-accent text-4xl">
                      workspace_premium
                    </span>
                    <div class="flex-1">
                      <div class="font-semibold text-accent mb-1">
                        {characterPack.value.name}
                      </div>
                      <div class="text-sm text-base-content/70">
                        {characterPack.value.description}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          <div class="divider">{t("customer.group_order.what_you_get")}</div>

          <div class="space-y-3">
            <div class="flex items-start gap-3">
              <span class="material-symbols-outlined text-success text-2xl">
                check_circle
              </span>
              <div class="flex-1">
                <div class="font-semibold text-base-content">
                  {t("customer.group_order.unique_identity")}
                </div>
                <div class="text-sm text-base-content/70">
                  {t("customer.group_order.unique_identity_copy")}
                </div>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <span class="material-symbols-outlined text-success text-2xl">
                check_circle
              </span>
              <div class="flex-1">
                <div class="font-semibold text-base-content">
                  {t("customer.group_order.realtime_updates")}
                </div>
                <div class="text-sm text-base-content/70">
                  {t("customer.group_order.realtime_updates_copy")}
                </div>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <span class="material-symbols-outlined text-success text-2xl">
                check_circle
              </span>
              <div class="flex-1">
                <div class="font-semibold text-base-content">
                  {t("customer.group_order.easy_coordination")}
                </div>
                <div class="text-sm text-base-content/70">
                  {t("customer.group_order.easy_coordination_copy")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LemmonModal>
    );
  },
});
